module.exports = __webpack_public_path__ + "static/media/6.3 Blumenstillleben Maltechnik klein.821d814f.jpg";